var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pis-pending"},[_c('h2',{staticClass:"normal"},[_vm._v(_vm._s(_vm.$t('thankYou.pending.header')))]),_c('p',[_vm._v(_vm._s(_vm.$t('thankYou.pending.description')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }